import React from "react";
import styled from "styled-components";
import { grid, flexbox, background, border, layout, position, space } from "styled-system";
import { GridProps } from "./types";

const Grid = styled.div<GridProps>`
  display: grid;
  ${flexbox}
  ${grid}
  ${background}
  ${border}
  ${layout}
  ${position}
  ${space}
`;

export default Grid;
